export default "__VITE_ASSET__7a760119__"